import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { userUi } from "./userUi";

const headerCols = [
	{ flex: 1.4, minWidth: 240 },
	{ width: 110 },
	{ width: 130 },
	{ flex: 0.8, minWidth: 150 },
	{ flex: 0.8, minWidth: 150 },
	{ width: 130 },
	{ flex: 1.2, minWidth: 220 },
];

const colSx = (col) => ({
	flex: col.flex ?? `0 0 ${col.width}px`,
	width: col.width,
	minWidth: col.minWidth || col.width,
	px: 1,
	boxSizing: "border-box",
});

const UsersLoadingSkeleton = ({ rows = 10, rowHeight = 56 }) => (
	<Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				height: 48,
				px: 2,
				borderBottom: `1px solid ${userUi.border}`,
				bgcolor: "#FAFAFA",
				flexShrink: 0,
			}}>
			<Skeleton variant="rounded" width={320} height={36} animation="wave" />
		</Box>
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				height: 48,
				px: 1,
				borderBottom: `1px solid ${userUi.border}`,
				bgcolor: "#FAFAFA",
				flexShrink: 0,
			}}>
			{headerCols.map((col, idx) => (
				<Box key={`h-${idx}`} sx={colSx(col)}>
					<Skeleton variant="text" width={idx === 0 ? "40%" : "70%"} height={22} animation="wave" />
				</Box>
			))}
		</Box>
		<Box sx={{ flex: 1, overflow: "hidden" }}>
			{Array.from({ length: rows }).map((_, rowIdx) => (
				<Box
					key={rowIdx}
					sx={{
						display: "flex",
						alignItems: "center",
						height: rowHeight,
						px: 1,
						borderBottom: `1px solid ${userUi.border}`,
					}}>
					<Box sx={{ ...colSx(headerCols[0]), display: "flex", alignItems: "center", gap: 1.25 }}>
						<Skeleton variant="circular" width={32} height={32} animation="wave" />
						<Box sx={{ flex: 1, minWidth: 0 }}>
							<Skeleton variant="text" width="70%" height={16} animation="wave" />
							<Skeleton variant="text" width="50%" height={14} animation="wave" />
						</Box>
					</Box>
					<Box sx={colSx(headerCols[1])}>
						<Skeleton variant="rounded" width={72} height={24} animation="wave" />
					</Box>
					<Box sx={colSx(headerCols[2])}>
						<Skeleton variant="text" width="80%" height={18} animation="wave" />
					</Box>
					<Box sx={colSx(headerCols[3])}>
						<Skeleton variant="text" width="75%" height={18} animation="wave" />
					</Box>
					<Box sx={colSx(headerCols[4])}>
						<Skeleton variant="text" width="75%" height={18} animation="wave" />
					</Box>
					<Box sx={colSx(headerCols[5])}>
						<Skeleton variant="text" width="80%" height={18} animation="wave" />
					</Box>
					<Box sx={{ ...colSx(headerCols[6]), display: "flex", gap: 0.75 }}>
						<Skeleton variant="rounded" width={72} height={24} animation="wave" />
						<Skeleton variant="rounded" width={56} height={24} animation="wave" />
					</Box>
				</Box>
			))}
		</Box>
	</Box>
);

export default UsersLoadingSkeleton;
